"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LOADING_DURATION = exports.UID_MASK_END = exports.UID_MASK_START = exports.LOAD_TIMEOUT = exports.PAD_LENGTH = exports.TIMESTAMP_MILLISECOND = exports.TIMESTAMP_SECOND_LENGTH = exports.PAGE_SIZE = exports.DEFAULT_OPTION = void 0;
exports.DEFAULT_OPTION = {
    actionIds: '0',
    content: '未完成'
};
exports.PAGE_SIZE = 10;
// 时间戳相关常量
exports.TIMESTAMP_SECOND_LENGTH = 10; // 秒级时间戳长度
exports.TIMESTAMP_MILLISECOND = 1000; // 毫秒转换倍数
exports.PAD_LENGTH = 2; // 日期格式化补零长度
// 加载超时时间（毫秒）
exports.LOAD_TIMEOUT = 1000;
// UID 脱敏显示相关常量
exports.UID_MASK_START = 2; // 显示前几位
exports.UID_MASK_END = 2; // 显示后几位
exports.LOADING_DURATION = 3; // loading 显示时长（秒）
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29uc3RhbnRzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiY29uc3RhbnRzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFhLFFBQUEsY0FBYyxHQUFHO0lBQzFCLFNBQVMsRUFBRSxHQUFHO0lBQ2QsT0FBTyxFQUFFLEtBQUs7Q0FDakIsQ0FBQztBQUVXLFFBQUEsU0FBUyxHQUFHLEVBQUUsQ0FBQztBQUU1QixVQUFVO0FBQ0csUUFBQSx1QkFBdUIsR0FBRyxFQUFFLENBQUMsQ0FBQyxVQUFVO0FBQ3hDLFFBQUEscUJBQXFCLEdBQUcsSUFBSSxDQUFDLENBQUMsU0FBUztBQUN2QyxRQUFBLFVBQVUsR0FBRyxDQUFDLENBQUMsQ0FBQyxZQUFZO0FBRXpDLGFBQWE7QUFDQSxRQUFBLFlBQVksR0FBRyxJQUFJLENBQUM7QUFDakMsZUFBZTtBQUNGLFFBQUEsY0FBYyxHQUFHLENBQUMsQ0FBQyxDQUFDLFFBQVE7QUFDNUIsUUFBQSxZQUFZLEdBQUcsQ0FBQyxDQUFDLENBQUMsUUFBUTtBQUUxQixRQUFBLGdCQUFnQixHQUFHLENBQUMsQ0FBQyxDQUFDLGtCQUFrQiJ9